module.exports = __webpack_public_path__ + "static/img/tjlx.ea01d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/consult/image/tjlx.png
// module id = 2OYq
// module chunks = 6